import { createContext, useContext, useEffect, useState } from "react";
import { T } from "./translations";

const LangContext = createContext(null);

const resolve = (lang, path) =>
  path.split(".").reduce((o, k) => (o != null ? o[k] : undefined), T[lang]);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("maprem-lang");
    return ["en", "hi", "gu"].includes(saved) ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("maprem-lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = (path) => resolve(lang, path) ?? resolve("en", path) ?? path;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
